<script>

import { ChiRhosNext , ChiRhos } from "@paladin/core"

import {
  PersonApi,
  GroupApi,
  GroupTypeApi,
  TemplateApi,
  RoleApi,
  EventApi,
  EventSeriesApi,
  EventTypeApi,
  ApiPagedFilteredRequest,
  ApiEntityWithDeletedRequest,
  ApiEventRequest,
  ApiEntityRequest,
  ApiEntityPagedRequest,
  GroupConstruct,
  ApiProvisionRequest,
  ApiMembershipRequest,
  InviteConstruct,
  GroupMembershipInvite,
  NotificationConstruct,
  // EventConstruct,
  // Limit,
  // RoleLimit,
  // Recurrence,
  // Interval,
  // EventSeriesConstruct,
  InviteTo,
} from '@chirhos/chirhos-api'


// import appConfig from '@src/app.config'
import { bTreeView } from 'bootstrap-vue-treeview'
// import PaladinPersonLookup from '../../../../library/components/personlookup/paladin-person-lookup'
import PaladinFileUpload from '../../../components/file-upload/paladin-file-upload'
import PaladinNotes from '../../../components/notes/paladin-notes'
import PaladinReports from '../../../components/reporting/paladin-reports'
import PaladinEvent from '../../../components/event/paladin-event'
import PaladinMemberExport from '../../../components/member-export/paladin-member-export'
import PaladinDistributionLists from '../../../components/distribution-lists/paladin-distribution-lists'
import PaladinGroupSettings from '../../../components/settings/paladin-group-settings'
import PaladinGroupProtectedProperties from '../../../components/protected-properties/paladin-group-protected-properties'
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
// import { ModalPlugin } from 'bootstrap-vue'

import { PaladinPersonLookup, } from '@paladin/core-components'

const ChiRhosNextApi = new ChiRhosNext().api()

let ChiRhosApi = new ChiRhos().api()

var personApi = new PersonApi(ChiRhosApi)
var groupApi = new GroupApi(ChiRhosApi)
var groupTypeApi = new GroupTypeApi(ChiRhosApi)
var templateApi = new TemplateApi(ChiRhosApi)
var roleApi = new RoleApi(ChiRhosApi)
var eventApi = new EventApi(ChiRhosApi)
var eventSeriesApi = new EventSeriesApi(ChiRhosApi)
var eventTypeApi = new EventTypeApi(ChiRhosApi)

export default {
  page: {
    title: 'Browse',
    // meta: [{ name: 'description', content: appConfig.description }],
  },
  // eslint-disable-next-line
  components: { bTreeView, PaladinPersonLookup, PaladinFileUpload, PaladinNotes, PaladinReports, VueCal, Multiselect, PaladinEvent, PaladinGroupSettings, PaladinMemberExport, PaladinDistributionLists, PaladinGroupProtectedProperties, },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isCollapsed: false,
      // Data bound to Treeview
      showDeleted: false,
      showGroupTypes: false,
      groupTypes: {},
      treeData: [
        {
          id: 1,
          name: 'Loading...',
          icon: 'fa fa-spinner spinner fa-spin',
        },
      ],
      // Treeview context menu
      contextMenuItems: [
        { code: 'DELETE_NODE', label: 'Delete group' },
        { code: 'RESTORE_NODE', label: 'Restore group' },
        { code: 'CUT_NODE', label: 'Cut group' },
        { code: 'PASTE_NODE', label: 'Paste group' },
        // {
        //   code: 'ADD_CHILD_NODE',
        //   label: 'Add child',
        // },
        // { code: 'RENAME_NODE', label: 'Rename' },
      ],
      page: {
        // Root groups retrieved on load from ChiRhos
        rootGroups: null,
        // List of templaltes that can be provisioned
        provisionTemplates: null,
        // Selected node in treeview
        selectedNode: null,
        // The current selected tab in details view
        selectedTab: 'members',
        tabLoading: false,
      },
      uniqueId: 'default',
      selectedDateFrom: moment().startOf('week'),
      selectedDateTo: moment().endOf('week'),
      // Contains all data for current active group
      activeGroup: {
        // Active group data
        data: null,
        roles: [],
        // Usage data
        usage: null,
        // Latest (based on current selection) groups returned from ChiRhos
        children: null,
        // GroupType data returned for current selected group
        groupTypes: null,
        // Data for the members tab
        members: {
          // List of members
          data: null,
          users: [],
          roles: [],
          memberships: [],
          // Add new Group form
          inviteMemberForm: {
            person: null,
          },
          inviteExternalMemberForm: {
            firstName: '',
            lastName: '',
            email: '',
            alternativeEmail: '',
            mobilePhone: '',
          },
        },
        notifications: {
          sendNotificationForm: {
            subject: '',
            shortMessage: '',
            sendSms: false,
            bodyText: '',
            bodyHtml: '',
            isNotification: true,
          },
        },
        // Data for the resources tab
        resources: {
          // List of resources
          data: null,
        },
        // Data for the events tab
        events: {
          // List of events
          data: [],
          edit: {
            series: false,
            showPanel: false,
            showModal: false,
            event: {},
            currentEventType: {},
            title: '',
            currentHours: 0,
            currentMinutes: 0,
          },
          eventTypes: [],
        },
        notes: {
          componentKey: 0,
        },
      },
      // Add new Group form
      addGroupForm: {
        name: '',
        // Item selected in the GroupTypes dropdown (current group view)
        type: null,
      },
      provisionGroupForm: {
        name: '',
        // Item selected in the ProvisionTemplates dropdown
        type: -1,
      },
      allRoles: [],
      cut:{
        id: null,
        parentType: null,
      },
      groupInviteCode: null,
    }
  },
  computed: {
    computedLeftPaneHigh: function()
    {
      return this.isCollapsed ? 'auto' : '5';
    },
    computedLeftPaneLow: function()
    {
      return this.isCollapsed ? 'auto' : '6';
    },
    computedRightPaneHigh: function()
    {
      return this.isCollapsed ? '*' : '7';
    },
    computedRightPaneLow: function()
    {
      return this.isCollapsed ? '*' : '6';
    },
    // Group Type ptions for the dropdown in the current active group view
    selectedGroupTypeOptions: function() {
      if (this.activeGroup.groupTypes) {
        return this.activeGroup.groupTypes.data.map((item) => {
          return {
            value: item.entity.entityId,
            text: item.entity.name,
          }
        })
      } else {
        return []
      }
    },
    // Template options for he provision dropdown
    provisionTemplatesOptions: function() {
      if (this.page.provisionTemplates) {
        return this.page.provisionTemplates.data.map((item) => {
          return {
            value: item.entity.entityId,
            text: item.entity.name,
          }
        })
      } else {
        return []
      }
    },
  },
  watch: {
  },
  mounted: function() {
    this.$nextTick(function() {
      templateApi.List().then(
        (response) => {
          // console.log(response)
          this.page.provisionTemplates = response
        },
        (error) => {
          console.error(error)
          this.$toast(error, 'error')
        }
      )
      this.initTreeview()
    })
  },
  created: function() {
  },
  methods: {
    updateGroupTypes(node) {

      var children = this.iterateTree(node)
      var setGroupFullNames = this.setGroupFullNames // save the method for use in the response
      var showGroupTypes = this.showGroupTypes

      if(children)
      {
        var groupTypes = this.groupTypes

        for(var child in children)
        {
          if(!groupTypes[child])
          {
            groupTypeApi
            .Get({
              request: new ApiEntityRequest(child)
            })
            .then(
              (response) => {
                groupTypes[response.data.entity.entityId] = response

                console.log('Cached group:' + response.data.entity.name)

                if(showGroupTypes)
                {
                  setGroupFullNames(children[response.data.entity.entityId], response)
                }
              },
              (error) => {
                console.error(error)
                this.$toast(error, 'error')
              }
            )
          }
          else
          {
            if(showGroupTypes)
            {
              setGroupFullNames(children[child], groupTypes[child])
            }
          }
        }
      }
    },
    setGroupFullNames(children, groupType)
    {
      children.forEach(function (value){
        value.name = value.name + ' (' + groupType.data.entity.name + ')'
      })
    },
    iterateTree(node)
    {
      var update = [];

      if(node)
      {
        var iterateTree = this.iterateTree

        node.forEach(function(value) {
          if(!value.fullName)
          {
              if(!update[value.type])
              {
                update[value.type] = []
              }

              update[value.type].push(value)
              value.fullName = true
          }

          if(value.children)
          {
            var children = iterateTree(value.children)

            if(children)
            {
              for(var child in children)
              {
                if(!update[child])
                {
                  update[child] = []
                }

                children[child].forEach(function(sub) {
                  update[child].push(sub)
                })
              }
            }
          }
        })
      }

      return update
    },
    async renderGroupTypes(node)
    {
      this.updateGroupTypes(node)
    },
    localDateTime(dt)
    {
      return moment(dt).local().format('LLLL')
    },
    initTreeview() {
      groupApi
        .ListRootGroups({
          request: new ApiPagedFilteredRequest(null, 1, 100, this.showDeleted, { property: "entity.name", direction: "asc" }, null),
        })
        .then(
          (response) => {
            this.page.rootGroups = response
            this.treeData = response.data.map((item) => {
              // if (
              //   this.page.groupsCache &&
              //   !this.page.groupsCache.find(function(obj) {
              //     return obj.entityId === item.entity.entityId
              //   })
              // ) {
              //   this.page.groupsCache.push(item)
              // }
              return {
                parentNode: null,
                id: item.entity.entityId,
                parent: item.entity.belongsTo,
                parentType: null,
                icon: 'fa fa-landmark landmark',
                type: item.entity.type,
                fullName: false,
                name: item.entity.name// + ' ' + getGroupType(item.entity.type).entity.name,
              }
            })
            this.renderGroupTypes(this.treeData);
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    initSubscriptionTab() {

    },
    initProtectedPropertiesTab() {

    },
    async initMembersTab() {
      // console.log('Members tab loaded')

      let _activeGroupEntityId = this.activeGroup.data.entity.entityId

      personApi
        .ListForGroup({
          request: new ApiEntityPagedRequest(this.page.selectedNode.data.id, 1, 100, false, null, null, null),
        })
        .then((response) => {
          this.activeGroup.members.data = response.data
          var _memberships = {
            members: [],
            pendingApproval: [],
            pendingAcceptance: [],
            // pendingApprovalAndAcceptance: [],
          }

          if (this.activeGroup.members.data) {
            // console.log(
            //   'this.activeGroup.members.data: ',
            //   this.activeGroup.members.data
            // )
            this.activeGroup.members.data.forEach((member) => {
              // console.log(' - member: ', member)
              if (member.entity.memberOfGroup) {
                member.entity.memberOfGroup.forEach((membership) => {
                  if(membership.entityId === _activeGroupEntityId)
                  {
                    // console.log('   - membership: ', membership)

                    // Resolve role
                    // roleEntityId
                    let _role = this.activeGroup.members.roles.find(function(obj) {
                      if (obj) return obj.value === membership.roleEntityId
                    })

                    if (_role) {
                      let _id = member.entity.entityId + '_' + _role.value
                      // accepted
                      // approvedAndActive

                      // Members
                      // Members Awaiting Approval
                      // Members Awaiting Acceptance
                      // Members Awaiting Approval &amp; Acceptance
                      if (membership.approvedAndActive && membership.accepted) {
                        _memberships.members.push({
                          id: _id,
                          member: member,
                          role: _role,
                        })
                      }
                      if (!membership.accepted) {
                        _memberships.pendingAcceptance.push({
                          id: _id,
                          member: member,
                          role: _role,
                        })
                      }
                      if (!membership.approvedAndActive) {
                        _memberships.pendingApproval.push({
                          id: _id,
                          member: member,
                          role: _role,
                        })
                      }
                      // if(!approvedAndActive && !accepted) {
                      //   _memberships.pendingApprovalAndAcceptance.push({
                      //     id: _id,
                      //     member: member,
                      //     role: _role
                      //   })
                      // }
                    }
                  }
                })
              }
            })
          }

          // console.log('_memberships: ', _memberships)
          this.activeGroup.members.memberships = _memberships
        })
      // // Get roles for group type
      // roleApi
      //   .ListForGroupType({
      //     request: new ApiEntityWithDeletedRequest(this.page.selectedNode.data.type),
      //   })
      //   .then(
      //     (response) => {
      //       // Set roles object to data for use in select control
      //       this.activeGroup.members.roles = response.data.map((item) => {
      //         return {
      //           text: item.entity.name,
      //           value: item.entity.entityId,
      //         }
      //       })
      //       // console.log('this.activeGroup.members.roles: ', this.activeGroup.members.roles)

      //       // Get members for selected group
      //       personApi
      //         .ListForGroup({
      //           request: new ApiEntityPagedRequest(this.page.selectedNode.data.id, 1, 100, false, null, null, null),
      //         })
      //         .then(
      //           (response) => {
      //             // set member data
      //             this.activeGroup.members.data = response.data
      //             var _memberships = {
      //               members: [],
      //               pendingApproval: [],
      //               pendingAcceptance: [],
      //               // pendingApprovalAndAcceptance: [],
      //             }

      //             if (this.activeGroup.members.data) {
      //               // console.log(
      //               //   'this.activeGroup.members.data: ',
      //               //   this.activeGroup.members.data
      //               // )
      //               this.activeGroup.members.data.forEach((member) => {
      //                 // console.log(' - member: ', member)
      //                 if (member.entity.memberOfGroup) {
      //                   member.entity.memberOfGroup.forEach((membership) => {
      //                     // console.log('   - membership: ', membership)

      //                     // Resolve role
      //                     // roleEntityId
      //                     let _role = this.activeGroup.members.roles.find(function(obj) {
      //                       if (obj) return obj.value === membership.roleEntityId
      //                     })

      //                     if (_role) {
      //                       let _id = member.entity.entityId + '_' + _role.value
      //                       // accepted
      //                       // approvedAndActive

      //                       // Members
      //                       // Members Awaiting Approval
      //                       // Members Awaiting Acceptance
      //                       // Members Awaiting Approval &amp; Acceptance
      //                       if (membership.approvedAndActive && membership.accepted) {
      //                         _memberships.members.push({
      //                           id: _id,
      //                           member: member,
      //                           role: _role,
      //                         })
      //                       }
      //                       if (!membership.accepted) {
      //                         _memberships.pendingAcceptance.push({
      //                           id: _id,
      //                           member: member,
      //                           role: _role,
      //                         })
      //                       }
      //                       if (!membership.approvedAndActive) {
      //                         _memberships.pendingApproval.push({
      //                           id: _id,
      //                           member: member,
      //                           role: _role,
      //                         })
      //                       }
      //                       // if(!approvedAndActive && !accepted) {
      //                       //   _memberships.pendingApprovalAndAcceptance.push({
      //                       //     id: _id,
      //                       //     member: member,
      //                       //     role: _role
      //                       //   })
      //                       // }
      //                     }
      //                   })
      //                 }
      //               })
      //             }
      //             // console.log('_memberships: ', _memberships)
      //             this.activeGroup.members.memberships = _memberships
      //           },
      //           (error) => {
      //             console.error(error)
      //             this.$toast(error, 'error')
      //           }
      //         )
      //     },
      //     (error) => {
      //       console.error(error)
      //       this.$toast(error, 'error')
      //     }
      //   )
    },
    initMemberExportTab() {
       groupTypeApi
        .ListChildGroupTypes({
          request: new ApiEntityPagedRequest(this.page.selectedNode.data.type, 1, 100, false, null, { property: "entity.name", direction: "asc" }, null),
        })
        .then(
          (data) => {
            this.activeGroup.groupTypes = data
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
      // console.log('Resources tab loaded')
      // Get resources for selected group
    },
    initNotificationsTab() {
      // console.log('Resources tab loaded')
      // Get resources for selected group
    },
    initResourcesTab() {
      // console.log('Resources tab loaded')
      // Get resources for selected group
      this.loadResources()
    },
    initDistributionListsTab()
    {
      // todo
    },
    initEventsTab() {
      // console.log('Events tab loaded')

      eventTypeApi
        .ListForGroupType({
          request: new ApiEntityWithDeletedRequest(this.page.selectedNode.data.type),
        })
        .then(
          (response) => {
            this.activeGroup.events.eventTypes = response.data.map((item) => {
              // console.log(item)
              return {
                text: item.entity.name,
                value: item.entity.entityId,
              }
            })

            this.loadEvents(this.selectedDateFrom, this.selectedDateTo)
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    initAddTab() {
      // console.log('Add tab loaded')
      // Get allowed group types for this group type
      groupTypeApi
        .ListChildGroupTypes({
          request: new ApiEntityPagedRequest(this.page.selectedNode.data.type, 1, 100, false, null, { property: "entity.name", direction: "asc" }, null),
        })
        .then(
          (data) => {
            this.activeGroup.groupTypes = data
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    initNotesTab() {
      // console.log('init notes tab')
      this.activeGroup.notes.componentKey += 1
    },
    initReportsTab() {
      groupTypeApi
        .ListChildGroupTypes({
          request: new ApiEntityPagedRequest(this.page.selectedNode.data.type, 1, 100, false, null, { property: "entity.name", direction: "asc" }, null),
        })
        .then(
          (data) => {
            this.activeGroup.groupTypes = data
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    async nodeSelect(node, isSelected) {
      if (isSelected) {
        if (node.data.id !== 100) {
          this.page.selectedNode = node

          this.activeGroup.events.edit.showModal = false
          this.activeGroup.events.edit.showPanel = false

          // get selected group and set to activeGroup.data
          var _groupPromise = groupApi.Get({
            request: new ApiEntityRequest(node.data.id),
          })

          // Get child groups for selected group
          var _groupChildrenPromise = groupApi.ListChildGroups({
            request: new ApiEntityPagedRequest(node.data.id, 1, 100, this.showDeleted, null, { property: "entity.name", direction:"asc" }, null),
          })

          var _rolePromise = roleApi.ListForGroupType({
            request: new ApiEntityWithDeletedRequest(this.page.selectedNode.data.type),
          })

          let _allRolesPromise = roleApi
            .ListAllForOrganizationContaining({
              request: new ApiEntityRequest(this.page.selectedNode.data.type),
            })

          let _groupDataResponse = await Promise.all([_groupPromise, _groupChildrenPromise, _rolePromise, _allRolesPromise]).then(
            function(values) {
              return values
            }
          )

          // Handle Promise 1
          this.activeGroup.data = _groupDataResponse[0].data

          this.uniqueId = this.activeGroup.data.entity.entityId

          // Handle Promise 2
          this.activeGroup.children = _groupDataResponse[1]

          if (node.data['children'] === undefined) {
            node.$set(node.data, 'children', [])
          } else {
            node.data['children'] = []
          }
          _groupDataResponse[1].data.forEach((item) => {
            // if (
            //   this.page.groupsCache &&
            //   !this.page.groupsCache.find(function(obj) {
            //     return obj.entityId === item.entity.entityId
            //   })
            // ) {
            //   this.page.groupsCache.push(item)
            // }
            node.data.children.push({
              parentNode: node,
              id: item.entity.entityId,
              parent: item.entity.belongsTo,
              parentType: node.data.type,
              name: item.entity.name,
              type: item.entity.type,
              children: [],
              icon: 'fa fa-user-friends user-friends',
            })
          })
          node.expanded = true

          // Handle Promise 3
          this.activeGroup.roles = _groupDataResponse[2].data
          this.activeGroup.members.roles = this.activeGroup.roles.map((item) => {
            return {
              text: item.entity.name,
              value: item.entity.entityId,
            }
          })

          // Handle Promise 4

          this.allRoles = _groupDataResponse[3].data.map((item) => {
            return {
              value: item.roleEntityId,
              text: `${item.roleName} (${item.groupTypeName})`,
            }
          })

          // lastly update group names with type

          this.renderGroupTypes(this.treeData)
        }

        if (this.page.selectedTab === 'subscription') {
          this.initSubscriptionTab()
        } else if (this.page.selectedTab === 'protectedProperties') {
          this.initProtectedPropertiesTab()
        } else if (this.page.selectedTab === 'members') {
          this.initMembersTab()
        } else if (this.page.selectedTab === 'resources') {
          this.initResourcesTab()
        } else if (this.page.selectedTab === 'distributionLists') {
          this.initDistributionListsTab()
        } else if (this.page.selectedTab === 'events') {
          this.initEventsTab()
        } else if (this.page.selectedTab === 'add') {
          this.initAddTab()
        } else if (this.page.selectedTab === 'notes') {
          this.initNotesTab()
        } else if (this.page.selectedTab === 'memberExport') {
          this.initMemberExportTab()
        } else if (this.page.selectedTab === 'reports') {
          this.initReportsTab()
        }
      } else if (node.data === this.page.selectedNode) {
        // this.page.selectedNode = null
        // this.currentGroups = null
      }
      // this.initMembersTab()
    },
    async menuItemSelected(item, node) {
      if (item.code === 'ADD_CHILD_NODE') {
        node.appendChild({
          id: 100,
          name: 'My new node',
        })
      } else if (item.code === 'DELETE_NODE') {

        let parentNode = node.data.parentNode
        groupApi.Delete({ entityId: this.activeGroup.data.entity.entityId }).then(
          async (/* data */) => {
            // console.log(data)
            await this.nodeSelect(parentNode, true)
            this.$toast('Group successfully deleted', 'success')
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
      } else if (item.code === 'RESTORE_NODE') {
        groupApi.Restore({ entityId: this.activeGroup.data.entity.entityId }).then(
          (/* data */) => {
            // console.log(data)
            this.$toast('Group successfully restored', 'success')
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
      } else if (item.code === 'CUT_NODE') {
        if(this.activeGroup.data.entity.belongsTo === '00000000-0000-0000-0000-000000000000')
        {
          this.$toast('You cannot cut a root group', 'error')
        }
        else
        {
          this.cut.id = this.activeGroup.data.entity.entityId
          this.cut.parentType = node.data.parentType

          this.$toast('Group cut to clipboard', 'success')
        }
      } else if (item.code === 'PASTE_NODE') {
        if(!this.cut.parentType)
        {
          this.$toast('Nothing in cut clipboard', 'error')
        }
        else if(node.data.type !== this.cut.parentType)
        {
          this.$toast('You can only paste the group in the clipboard into a parent of the same type as the original parent', 'error')
        }
        else
        {
          let destination = node

          await ChiRhosNextApi.GroupApi.get({entityId: this.cut.id}).then(
            async (response) => {
              if(response.data)
              {
                response.data.entity.belongsTo = destination.data.id

                await ChiRhosNextApi.GroupApi.post(response.data.entity).then(
                  async (response) => {
                    this.$toast("Group moved", "success")
                    await this.nodeSelect(destination, true)
                  },
                  error => {
                    console.error(error)
                    error.json().then(body => {
                      this.$toast(body.Message, "error")
                    })
                  }
                )
              }},
            error => {
              console.error(error);
              error.json().then(body => {
                this.$toast(body.Message, "error")
              })
            }
          )
        }
      }
    },
    subscriptionTabSelected(/* evt */) {
      this.page.selectedTab = 'subscription'
      // console.log('Subscription tab selected')
      this.initSubscriptionTab()
    },
    protectedPropertiesTabSelected(/* evt */) {
      this.page.selectedTab = 'protectedProperties'
      // console.log('Subscription tab selected')
      this.initProtectedPropertiesTab()
    },
    membersTabSelected(/* evt */) {
      this.page.selectedTab = 'members'
      // console.log('Members tab selected')
      this.initMembersTab()
    },
    notificationsTabSelected(/* evt */) {
      this.page.selectedTab = 'notifications'
      // console.log('Notifications tab selected')
      this.initNotificationsTab()
    },
    resourcesTabSelected(/* evt */) {
      this.page.selectedTab = 'resources'
      // console.log('Resources tab selected')
      this.initResourcesTab()
    },
    distributionListsTabSelected(/* evt */) {
      this.page.selectedTab = 'distributionLists'
      // console.log('Resources tab selected')
      this.initDistributionListsTab()
    },
    eventsTabSelected(/* evt */) {
      this.page.selectedTab = 'events'
      // console.log('Events tab selected')
      this.initEventsTab()
    },
    addTabSelected(/* evt */) {
      this.page.selectedTab = 'add'
      // console.log('Add child group tab selected')
      this.initAddTab()
    },
    notesTabSelected(/* evt */) {
      this.page.selectedTab = 'notes'
      // console.log('Add child group tab selected')
      this.initNotesTab()
    },
    memberExportTabSelected(/* evt */) {
      this.page.selectedTab = 'memberExport'
      // console.log('Add child group tab selected')
      this.initMemberExportTab()
    },
    reportsTabSelected() {
      this.page.selectedTab = 'reports'
      // console.log('Add child group tab selected')
      this.initReportsTab()
    },
    newGroupSubmit(evt) {
      evt.preventDefault()
      // var _selectedNode = this.page.selectedNode
      groupApi
        .Save({
          value: new GroupConstruct(
            this.addGroupForm.name,
            this.addGroupForm.type,
            this.activeGroup.data.entity.entityId
          ),
        })
        .then(
          (/* data */) => {
            this.addGroupForm.name = ''
            this.addGroupForm.type = null

            this.$toast('Group successfully saved', 'success')
            // console.log(_selectedNode)
            // if (_selectedNode.data['children'] === undefined) {
            //   _selectedNode.$set(_selectedNode.data, 'children', [])
            // } else {
            //   _selectedNode.data['children'] = []
            // }
            // var _data = data
            // _selectedNode.data.children.push({
            //   id: _data.entity.entityId,
            //   parent: _data.entity.belongsTo,
            //   name: _data.entity.name,
            //   type: _data.entity.type,
            //   children: [],
            // })
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    groupInviteAcceptSubmit(evt)
    {
      evt.preventDefault()

      ChiRhosNextApi.GroupApi.acceptInvite(this.groupInviteCode).then(
        response => {
          this.initTreeview()
          this.$toast("Invite accepted", "success")
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    provisionGroupSubmit(evt) {
      evt.preventDefault()

      let _provisionRequest = new ApiProvisionRequest(this.provisionGroupForm.name)

      if (this.provisionGroupForm.type) _provisionRequest.type = this.provisionGroupForm.type

      templateApi
        .Provision({
          provisionRequest: _provisionRequest,
        })
        .then(
          (/* data */) => {
            this.initTreeview()
            this.$toast('Group successfully provisioned', 'success')
            // this.$refs.tree.$forceUpdate()
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    inviteMemberSubmit(evt) {
      evt.preventDefault()

      personApi
        .AddGroupMembership({
          request: new ApiMembershipRequest(
            this.activeGroup.members.inviteMemberForm.person.entityId,
            this.page.selectedNode.data.id,
            this.activeGroup.members.inviteMemberForm.role
          ),
        })
        .then(
          (/* data */) => {
            this.$toast('Member successfully invited!', 'success')
            // this.$refs.tree.$forceUpdate()
            this.initMembersTab()
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    inviteExternalMemberSubmit(evt) {
      evt.preventDefault()

      groupApi
        .Invite({
          value: new InviteConstruct(
            new InviteTo(
              this.activeGroup.members.inviteExternalMemberForm.firstName,
              this.activeGroup.members.inviteExternalMemberForm.lastName,
              this.activeGroup.members.inviteExternalMemberForm.email,
              this.activeGroup.members.inviteExternalMemberForm.alternativeEmail,
              this.activeGroup.members.inviteExternalMemberForm.mobilePhone
            ),
            new GroupMembershipInvite(
              this.page.selectedNode.data.id,
              this.activeGroup.members.inviteExternalMemberForm.role
            )
          ),
        })
        .then(
          (/* data */) => {
            this.$toast('Member successfully invited!', 'success')
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    sendNotificationSubmit(evt) {
      evt.preventDefault()

      var construct = new NotificationConstruct(
            this.page.selectedNode.data.id,
            this.activeGroup.notifications.sendNotificationForm.subject,
            this.activeGroup.notifications.sendNotificationForm.shortMessage,
            this.activeGroup.notifications.sendNotificationForm.bodyText,
            this.activeGroup.notifications.sendNotificationForm.bodyHtml,
            this.activeGroup.notifications.sendNotificationForm.isNotification
          )

      construct.sendSms = this.activeGroup.notifications.sendNotificationForm.sendSms

      groupApi
        .CreateNotification({
          value: construct
        })
        .then(
          (/* data */) => {
            // clear fields
            this.activeGroup.notifications.sendNotificationForm.subject = ''
            this.activeGroup.notifications.sendNotificationForm.shortMessage = ''
            this.activeGroup.notifications.sendNotificationForm.sendSns = false
            this.activeGroup.notifications.sendNotificationForm.bodyText = ''
            this.activeGroup.notifications.sendNotificationForm.bodyHtml = ''
            this.activeGroup.notifications.sendNotificationForm.isNotification = true
            this.$toast('Notification successfully sent!', 'success')
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    async uploadGroupResource(formData) {
      // console.log('uploadGroupResource -> formData:')
      // for (var key of formData.entries()) {
      //   console.log(key[0] + ', ' + key[1])
      // }
      // return formData
      if (this.activeGroup.data.entity.entityId !== '0') {
        groupApi
          .SaveResource({
            contentType: 'multipart/form-data',
            // contentDisposition
            // headers
            // length
            // name
            // fileName
            resourceJson: JSON.stringify({
              belongsToEntityId: this.activeGroup.data.entity.entityId,
            }),
            formParams: formData,
          })
          .then(
            (response) => {
              this.loadResources()
              return response
            },
            (error) => {
              console.error(error)
              return error
            }
          )
      }
    },
    loadResources() {
      if (this.activeGroup.data.entity.entityId !== '0') {
        groupApi
          .ListResources({
            request: new ApiEntityPagedRequest(this.activeGroup.data.entity.entityId),
          })
          .then(
            (response) => {
              this.activeGroup.resources.data = response.data
              // resolve(response.data)
            },
            (error) => {
              console.error(error)
              // reject(error)
            }
          )
      }
    },
    downloadGroupResource(evt, resourceId) {
      // console.log(resourceId)
      evt.preventDefault()
      groupApi
        .GetResourceFile({
          request: new ApiEntityRequest(resourceId),
        })
        .then(
          (response) => {
            let _test = response.data
            console.log(_test)
            // resolve(response.data)
          },
          (error) => {
            console.error(error)
            // reject(error)
          }
        )
    },
    canEdit(person) {
      if (person && this !== undefined && this.user) {
        if (person.entityId === this.user.profile.entityId) return true

        var _user = this.user
        if (person.owners && person.owners.length > 0) {
          var match = person.owners.find(function(obj) {
            return obj === _user.profile.entityId
          })

          if(match) return true
        }
      }

      return false
    },
    loadEvents(from, to) {
      if (from && to) {
        // Get events for selected group
        eventApi
          .ListForGroup({
            request: new ApiEventRequest(from, to, false, this.page.selectedNode.data.id),
          })
          .then(
            (response) => {
              // console.log(response.data)
              this.activeGroup.events.data = response.data.map((item) => {
                let _format = 'YYYY-MM-DD HH:mm'
                let _start = moment(item.start)
                return {
                  start: _start.format(_format),
                  end: _start.add(item.minutesDuration, 'minutes').format(_format),
                  title: item.name,
                  event: item,
                }
              })
            },
            (error) => {
              console.error(error)
              this.$toast(error, 'error')
            }
          )
      } else {
        this.$toast('Please set valid start and end dates', 'error')
      }
    },
    getEvents(trigger, evt) {
      // console.log(trigger, evt)
      if (evt && evt.view !== 'year') {

        this.selectedDateFrom = moment(evt.startDate).startOf('week')
        this.selectedDateTo = moment(evt.endDate).endOf('week')

        this.loadEvents(this.selectedDateFrom, this.selectedDateTo)
      }
    },
    newEvent() {
        window.scrollTo(0,0)
        this.activeGroup.events.edit.series = false
        this.activeGroup.events.edit.showPanel = true
        this.activeGroup.events.edit.title = "Event: (create new)"
       this.activeGroup.events.edit.event = {}
//      this.activeGroup.events.edit.show = true
    },
    editThisEvent()
    {
        // location.hash = "#top"
        window.scrollTo(0,0)
        this.activeGroup.events.edit.showModal = false
        this.activeGroup.events.edit.series = false
        this.activeGroup.events.edit.showPanel = true
        this.activeGroup.events.edit.title = "Event: " + this.activeGroup.events.edit.event.name
    },
    editEventSeries()
    {
        // need to get the series

      this.activeGroup.events.edit.showModal = false

      eventSeriesApi
        .Get({
          request: this.activeGroup.events.edit.event.belongsToSeries,
        })
        .then(
          (response) => {
            window.scrollTo(0,0)
            this.activeGroup.events.edit.series = true
            this.activeGroup.events.edit.event = response.data.entity
            this.activeGroup.events.edit.showPanel = true
            this.activeGroup.events.edit.title = "Event Series: " + response.data.entity.name
          },
          (error) => {
            console.error(error)
            this.$toast(error, 'error')
          }
        )
    },
    setInvite(value)
    {
      this.activeGroup.members.inviteMemberForm.person = value
    },
    editEvent(trigger, evt) {
      // this.$toast('Event edit not implemented yet.', 'warning')
      // console.log(trigger, evt)
      // return false

      if (evt && evt.event) {
        let _event = evt.event

        this.activeGroup.events.edit.event = _event

        this.activeGroup.events.edit.currentEventType = {}

        var eventType = this.activeGroup.events.eventTypes.find(function(element) {
                return element.value === _event.type
        });

        if(eventType) this.activeGroup.events.edit.currentEventType = eventType;

        this.activeGroup.events.edit.currentHours = Math.floor(_event.minutesDuration / 60)
        this.activeGroup.events.edit.currentMinutes = _event.minutesDuration % 60

        this.activeGroup.events.edit.showModal = true
      }

      //   let _duration = moment.duration({"minutes": _event.minutesDuration})
      //   let _durationHours = _duration.hours()
      //   let _durationMinutes = _duration.minutes()

      //   // console.log('_duration', _duration)
      //   // console.log('_durationHours: ', _durationHours, '_durationMinutes: ', _durationMinutes)

      //   let _recurrence = {}
      //   if(_event.belongsToSeries){
      //     _recurrence = {
      //       occurences: 30,
      //       endBy: null,
      //       daily: {
      //         every: 1,
      //       },
      //       weeklyOnDays: {
      //         sunday: false,
      //         monday: false,
      //         tuesday: false,
      //         wednesday: false,
      //         thursday: false,
      //         friday: false,
      //         saturday: false,
      //       },
      //       weekly: {
      //         every: 1,
      //       },
      //       monthlyOnDay: {
      //         day: 0,
      //         every: 0,
      //       },
      //       monthly: {
      //         dayOfWeek: 0,
      //         week: 0,
      //         every: 0,
      //       },
      //     }
      //   }

      //   let _formData = {
      //     isRepeatEvent: !!_event.belongsToSeries,
      //     recurrenceType: 'daily',
      //     endType: 'never',
      //     durationHours: _durationHours,
      //     durationMinutes: _durationMinutes,
      //     recurrence: _recurrence,
      //     type: _event.type,
      //     belongsToGroup: _event.belongsTo,
      //     name: _event.name,
      //     start: _event.start,
      //     isOpen: true,
      //     limitToRoles: {
      //       roles: [],
      //       includeAncestors: true,
      //       includeDescendants: true,
      //     },
      //   }

      //   this.activeGroup.events.eventForm = _formData
      // }
    },
    viewDetail(person)
    {
        // todo?
    },
    removeMember(collection, member)
    {
      let _collection = collection
      let _member = member

      ChiRhosNextApi.PersonApi.removeGroupMembership({
        personEntityId: member.member.entity.entityId,
        toEntityId: this.activeGroup.data.entity.entityId,
        roleEntityId: member.role.value
      }).then(
        response => {
          this.$toast('Member successfully removed!', 'success')
          _collection.splice(
            _collection.indexOf(_member),
            1
          )
        },
        error => {
          console.error(error)
          error.json().then(body => {
            this.$toast(body.Message, "error")
          })
        }
      )
    },
    cancelEdit() {
//      this.activeGroup.events.edit.show = false
      this.activeGroup.events.edit.showPanel = false
      this.activeGroup.events.edit.event = {}

        window.scrollTo(0,0);
    },
    collapse(collapsed)
    {
      this.isCollapsed = collapsed
    },
  },
}
</script>

<template src="./browse.html"></template>
